export const PRESCRIBED_BURN_TREATMENT = "Prescribed Burn";
export const REVEGETATION_TREATMENT = "Revegetation";
export const GRAZING_TREATMENT = "Grazing";
export const PRUNING_TREATMENT = "Pruning";
export const UNDERSTORY_THINNING_TREATMENT = "Thinning";
export const MINERAL_EARTH_TREATMENT = "Mechanical (Mineral Earth)";
export const SILVICULTURE_TREATMENT = "Silviculture";
export const CHEMICAL_RETARDANT_TREATMENT = "Chemical Retardant";

// Note: PRUNING_TREATMENT and UNDERSTORY_THINNING_TREATMENT are intentionally
// omitted from the selectable list — they are no longer offered for new
// treatments. Their constants and configs below are retained so existing saved
// treatments of those types still render and edit correctly.
export const TREATMENT_TYPES: string[] = [
  PRESCRIBED_BURN_TREATMENT,
  REVEGETATION_TREATMENT,
  GRAZING_TREATMENT,
  SILVICULTURE_TREATMENT,
  MINERAL_EARTH_TREATMENT,
  CHEMICAL_RETARDANT_TREATMENT,
];

export interface TreatmentConfig {
  showVegClass: boolean;
  showVegDate: boolean;
  showFuel: boolean;
  showStartDate: boolean;
  showThinningFields?: boolean;
  showSilvicultureFields?: boolean;
  showRetardantFields?: boolean;
}

export const TREATMENT_CONFIGS: Record<string, TreatmentConfig> = {
  [PRESCRIBED_BURN_TREATMENT]: {
    showVegClass: false,
    showVegDate: false,
    showFuel: true,
    showStartDate: false,
  },
  [REVEGETATION_TREATMENT]: {
    showVegClass: true,
    showVegDate: true,
    showFuel: false,
    showStartDate: false,
  },
  [GRAZING_TREATMENT]: {
    showVegClass: false,
    showVegDate: false,
    showFuel: true,
    showStartDate: true,
  },
  [PRUNING_TREATMENT]: {
    showVegClass: false,
    showVegDate: false,
    showFuel: false,
    showStartDate: false,
  },
  [MINERAL_EARTH_TREATMENT]: {
    showVegClass: false,
    showVegDate: false,
    showFuel: true,
    showStartDate: false,
  },
  [UNDERSTORY_THINNING_TREATMENT]: {
    showVegClass: false,
    showVegDate: false,
    showFuel: false,
    showStartDate: false,
    showThinningFields: true,
  },
  [SILVICULTURE_TREATMENT]: {
    showVegClass: false,
    showVegDate: false,
    showFuel: false,
    showStartDate: false,
    showSilvicultureFields: true,
  },
  // A retardant removes no fuel, so there is no residual-fuel figure to ask
  // for — it takes a product, a coverage fraction and an application rate.
  [CHEMICAL_RETARDANT_TREATMENT]: {
    showVegClass: false,
    showVegDate: false,
    showFuel: false,
    showStartDate: false,
    showRetardantFields: true,
  },
};

export const DEFAULT_TREATMENT_CONFIG: TreatmentConfig = {
  showVegClass: false,
  showVegDate: false,
  showFuel: true,
  showStartDate: false,
};
